import { Box, Typography, useTheme } from '@mui/material';

import SectionTitle from './components/SectionTitle';

const contents = [
  'Tôi xác nhận rằng bác sĩ đã giải thích các điều sau:',
  'Tình trạng y tế của tôi và thủ tục đề xuất, bao gồm các liệu pháp bổ sung nếu bác sĩ phát hiện điều gì đó bất ngờ. Tôi hiểu các rủi ro, bao gồm những rủi ro cụ thể đối với tôi.',
  '(Sự gây mê cần thiết cho thủ tục này; Tôi hiểu các rủi ro, bao gồm những rủi ro cụ thể đối với tôi.)',
  'Các lựa chọn thủ tục/điều trị khác có liên quan và các rủi ro liên quan đến chúng.',
  'Tiên lượng của tôi và các rủi ro nếu không thực hiện thủ tục này.',
  'Không có sự đảm bảo rằng thủ tục sẽ cải thiện tình trạng của tôi dù đã được thực hiện với sự chăm sóc chuyên nghiệp.',
  '(Thủ tục có thể bao gồm truyền máu.)',
  'Mô và máu có thể được lấy ra và có thể được sử dụng cho việc chẩn đoán hoặc quản lý tình trạng của tôi, được lưu trữ và xử lý một cách nhạy cảm bởi bệnh viện.',
  'Nếu có các sự kiện nguy hiểm đe doạ tính mạng xảy ra trong khi thủ tục, chúng sẽ được điều trị dựa trên cuộc thảo luận của tôi với bác sĩ hoặc Kế hoạch Sơ cứu Cấp cứu của tôi.',
  'Một bác sĩ khác ngoài Bác sĩ Chuyên khoa có thể thực hiện thủ tục. Tôi hiểu rằng đây có thể là một bác sĩ đang trong quá trình đào tạo tiếp.',
  'Tôi đã có thể đặt câu hỏi và nêu ra những mối quan tâm với bác sĩ về tình trạng của tôi, thủ tục đề xuất và các rủi ro của nó, và các lựa chọn điều trị của tôi. Các câu hỏi và mối quan\n     tâm của tôi đã được thảo luận và được trả lời một cách đầy đủ và thỏa đáng.',
  'Tôi hiểu rằng tôi có quyền thay đổi ý kiến ​​bất cứ lúc nào, bao gồm sau khi tôi đã ký biểu mẫu này nhưng mong muốn thảo luận với bác sĩ của tôi.',
  'Tôi hiểu rằng hình ảnh hoặc video có thể được ghi lại như một phần trong quá trình thực hiện thủ tục và những hình ảnh hoặc video này sẽ giúp bác sĩ cung cấp điều trị phù hợp.',
];

const GeneralPateintConsentForm = () => {
  const { palette } = useTheme();

  return (
    <>
      <SectionTitle title="Biểu mẫu chập thuận chung cho bệnh nhân" />
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 10px auto',
        }}
      >
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: '15px',
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
          }}
        >
          Tôi xác nhận rằng tôi đã đọc và hiểu nội dung của thỏa thuận điều trị
          này, và tất cả các mục đã được điền đầy đủ trước khi tôi ký tên
        </Typography>
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '0px auto 10px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              • {v}
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '0px auto 0px auto',
        }}
      >
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: '15px',
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
          }}
        >
          Dựa trên những điều trên
        </Typography>
        <br />

        <Typography
          sx={{
            fontWeight: '400',
            fontSize: '15px',
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
            color: `${palette.primary.dark}`,
          }}
        >
          Tôi đã đọc và hiểu kỹ tất cả thông tin ở trên, và tôi hoàn toàn nhận
          thức về những gì mình đang ký kết. Tôi hiểu rằng tôi có thể yêu cầu
          bác sĩ của mình để giải thích chi tiết hơn. Tôi
          <br />
          đồng ý và cho phép thực hiện điều trị.
        </Typography>
      </Box>
    </>
  );
};

export default GeneralPateintConsentForm;
